// trigger preview deploy: ENGG-857
import { Partytown } from '@builder.io/partytown/react';
import { initMonitoring } from '@repo/monitoring';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import App from './App';
import { ENVIRONMENT, SENTRY_DSN } from './assets/env_constants';
import { listenForStaleBuild } from './utils/staleBuild';

// Initialize monitoring with universal error rules
initMonitoring({
  dsn: SENTRY_DSN,
  environment: ENVIRONMENT,

  release: __APP_RELEASE__,

  // To test error reporting in sandbox/development, uncomment:
  // captureErrors: true,

  errorRules: {
    captureOn5xx: true,
    captureOn4xx: false,
    captureNetworkErrors: false,
    captureTimeouts: true,
  },
  sentryOptions: {
    tracesSampleRate: ENVIRONMENT === 'production' ? 0.1 : 1.0,
  },
});

listenForStaleBuild();

const router = createBrowserRouter([
  {
    path: '/*',
    element: <App />,
  },
]);

const render = () => {
  const rootElement = document.getElementById('root');
  if (!rootElement) throw new Error('Failed to find the root element');

  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <Partytown forward={['dataLayer.push']} />
      <RouterProvider router={router} />
    </React.StrictMode>,
  );
};

render();
